module.exports = __webpack_public_path__ + "static/media/anuncio2.a17ca872.png";